import { useEffect, useState } from "react";

const API_URL = process.env.REACT_APP_API_URL || process.env.VITE_API_URL || "http://localhost:8080";
const MCP_HEADER = { "X-MCP-Protocol": "1.0" };

export default function Condominiums({ keycloak }) {
  const [condominiums, setCondominiums] = useState([]);
  const [selectedCondominium, setSelectedCondominium] = useState(null);
  const [commonAreas, setCommonAreas] = useState([]);
  const [rentals, setRentals] = useState([]);
  const [activeTab, setActiveTab] = useState("list");

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${keycloak.token}`,
    ...MCP_HEADER,
  };

  const loadCondominiums = async () => {
    const response = await fetch(`${API_URL}/api/condominiums`, { headers });
    const data = await response.json();
    setCondominiums(data || []);
  };

  useEffect(() => {
    loadCondominiums().catch((error) => console.error("Erro ao carregar condomínios", error));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadCommonAreas = async (condominiumId) => {
    const response = await fetch(`${API_URL}/api/condominiums/${condominiumId}/common-areas`, { headers });
    const data = await response.json();
    setCommonAreas(data || []);
  };

  const loadRentals = async (condominiumId) => {
    const response = await fetch(`${API_URL}/api/condominiums/${condominiumId}/rentals`, { headers });
    const data = await response.json();
    setRentals(data || []);
  };

  const createCondominium = async () => {
    const name = prompt("Nome do condomínio:");
    const address = prompt("Endereço:");
    const city = prompt("Cidade:");
    const state = prompt("Estado:");
    const totalUnits = prompt("Total de unidades:");
    if (name && address) {
      await fetch(`${API_URL}/api/condominiums`, {
        method: "POST",
        headers,
        body: JSON.stringify({ name, address, city, state, totalUnits: Number(totalUnits || 0) }),
      });
      loadCondominiums();
    }
  };

  const createCommonArea = async (condominiumId) => {
    const name = prompt("Nome do espaço:");
    const type = prompt("Tipo (SALAO, QUADRA, PISCINA, CHURRASQUEIRA, OUTROS):");
    const price = prompt("Preço do aluguel:");
    const capacity = prompt("Capacidade:");
    if (name && type) {
      await fetch(`${API_URL}/api/condominiums/${condominiumId}/common-areas`, {
        method: "POST",
        headers,
        body: JSON.stringify({
          name,
          type,
          rentalPrice: Number(price || 0),
          capacity: Number(capacity || 0),
          available: true,
        }),
      });
      loadCommonAreas(condominiumId);
    }
  };

  const createRental = async (condominiumId, commonAreaId) => {
    const tenantName = prompt("Nome do locatário:");
    const tenantPhone = prompt("Telefone:");
    const date = prompt("Data (YYYY-MM-DD):");
    const startTime = prompt("Hora início (HH:MM):");
    const endTime = prompt("Hora fim (HH:MM):");
    if (tenantName && date) {
      await fetch(`${API_URL}/api/condominiums/${condominiumId}/rentals`, {
        method: "POST",
        headers,
        body: JSON.stringify({
          commonAreaId,
          tenantName,
          tenantPhone,
          rentalDate: date,
          startTime: startTime || "10:00",
          endTime: endTime || "12:00",
          totalPrice: 0,
        }),
      });
      loadRentals(condominiumId);
    }
  };

  return (
    <div className="container">
      <section className="hero">
        <h1>Gerenciamento de Condomínios</h1>
        <p>
          Gerencie condomínios, espaços comuns e aluguel de salões e áreas públicas.
        </p>
      </section>

      <div style={{ display: "flex", gap: "1rem", marginBottom: "2rem", flexWrap: "wrap" }}>
        <button
          className={activeTab === "list" ? "btn-primary" : "btn-secondary"}
          onClick={() => setActiveTab("list")}
        >
          Condomínios
        </button>
        {selectedCondominium && (
          <>
            <button
              className={activeTab === "areas" ? "btn-primary" : "btn-secondary"}
              onClick={() => {
                setActiveTab("areas");
                loadCommonAreas(selectedCondominium);
              }}
            >
              Espaços Comuns
            </button>
            <button
              className={activeTab === "rentals" ? "btn-primary" : "btn-secondary"}
              onClick={() => {
                setActiveTab("rentals");
                loadRentals(selectedCondominium);
              }}
            >
              Aluguéis
            </button>
          </>
        )}
      </div>

      {activeTab === "list" && (
        <section>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.5rem" }}>
            <h2 className="section-title" style={{ margin: 0 }}>Condomínios Cadastrados</h2>
            <button className="btn-primary" onClick={createCondominium}>
              + Novo Condomínio
            </button>
          </div>
          <div className="grid grid-3">
            {condominiums.map((condo) => (
              <div key={condo.id} className="listing-card">
                <h4>{condo.name}</h4>
                <div style={{ color: "var(--text-secondary)", marginTop: "0.5rem" }}>
                  {condo.address}, {condo.city} - {condo.state}
                </div>
                <div style={{ color: "var(--text-secondary)", marginTop: "0.5rem" }}>
                  {condo.totalUnits} unidades
                </div>
                <button
                  className="btn-secondary"
                  onClick={() => {
                    setSelectedCondominium(condo.id);
                    setActiveTab("areas");
                    loadCommonAreas(condo.id);
                  }}
                  style={{ marginTop: "1rem", width: "100%" }}
                >
                  Gerenciar
                </button>
              </div>
            ))}
          </div>
        </section>
      )}

      {activeTab === "areas" && selectedCondominium && (
        <section>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.5rem" }}>
            <h2 className="section-title" style={{ margin: 0 }}>Espaços Comuns</h2>
            <button className="btn-primary" onClick={() => createCommonArea(selectedCondominium)}>
              + Novo Espaço
            </button>
          </div>
          <div className="grid grid-3">
            {commonAreas.map((area) => (
              <div key={area.id} className="listing-card">
                <div className="tag">{area.type}</div>
                <h4>{area.name}</h4>
                <div style={{ fontSize: "1.25rem", fontWeight: 700, color: "var(--brand-blue)", margin: "0.75rem 0" }}>
                  R$ {area.rentalPrice?.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}/dia
                </div>
                {area.capacity > 0 && (
                  <div style={{ color: "var(--text-secondary)" }}>
                    Capacidade: {area.capacity} pessoas
                  </div>
                )}
                <div style={{ 
                  marginTop: "0.5rem",
                  padding: "0.25rem 0.75rem",
                  borderRadius: "999px",
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  display: "inline-block",
                  background: area.available ? "var(--brand-green)20" : "#dc262620",
                  color: area.available ? "var(--brand-green)" : "#dc2626"
                }}>
                  {area.available ? "Disponível" : "Indisponível"}
                </div>
                <button
                  className="btn-secondary"
                  onClick={() => createRental(selectedCondominium, area.id)}
                  style={{ marginTop: "1rem", width: "100%" }}
                >
                  Reservar
                </button>
              </div>
            ))}
          </div>
        </section>
      )}

      {activeTab === "rentals" && selectedCondominium && (
        <section>
          <h2 className="section-title">Aluguéis de Espaços</h2>
          <div className="grid grid-3">
            {rentals.map((rental) => (
              <div key={rental.id} className="listing-card">
                <div className="tag">{rental.status}</div>
                <h4>{rental.tenantName}</h4>
                <div style={{ color: "var(--text-secondary)", marginTop: "0.5rem" }}>
                  <strong>Data:</strong> {rental.rentalDate}
                </div>
                <div style={{ color: "var(--text-secondary)" }}>
                  <strong>Horário:</strong> {rental.startTime} - {rental.endTime}
                </div>
                {rental.totalPrice > 0 && (
                  <div style={{ fontSize: "1.25rem", fontWeight: 700, color: "var(--brand-green)", margin: "0.75rem 0" }}>
                    R$ {rental.totalPrice?.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
                  </div>
                )}
                {rental.tenantPhone && (
                  <div style={{ color: "var(--text-secondary)" }}>
                    📞 {rental.tenantPhone}
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
